module.exports = __webpack_public_path__ + "img/Dantam Makeover 04.5ee9c83a.jpg";